import React, { useState, useRef, useEffect } from 'react';
import { ImageOptimizeProps } from './interface';

const ImageSplitOptimize: React.FC<ImageOptimizeProps> = props => {
  const { tips = ['优化前', '优化后'],
    imgList,
    getImgStatus,
    getImgState,
    getIsMoblie,
    defaultRange = 50,
    getRange } = props;
  const [range, setRange] = useState(defaultRange);
  const [imgState, setImgState] = useState<any>(null);
  const [bgPosition, setBgPosition] = useState('50%');
  const imgRef = useRef<any>(null);

  const containerRef = useRef<HTMLDivElement>(null);

  async function getImageSize() {
    const img = imgRef?.current;
    const container = containerRef?.current;
    if (!img || !container) {
      return;
    }
    
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    
    // 根据容器尺寸计算等比例缩放
    const scaleX = containerWidth / naturalWidth;
    const scaleY = containerHeight / naturalHeight;
    const scale = Math.min(scaleX, scaleY, 1); // 不超过原图尺寸
    
    const width = Math.floor(naturalWidth * scale);
    const height = Math.floor(naturalHeight * scale);
    
    console.log('getImageSize', width, height, img);
    
    const oImgState = {
      imgWidth: width,
      imgHeight: height,
      imgLeft: img?.offsetLeft,
      transform: {
        scaleX: scale,
        scaleY: scale,
        offsetY: img?.offsetTop,
        offsetX: img?.offsetLeft,
      },
    };
    await setImgState(oImgState);
    oImgState && await setBgPosition(`${(range / 100) * (oImgState?.imgLeft * 2 + oImgState?.imgWidth) - oImgState?.imgLeft}px`);
    if (getImgState) {
      getImgState(oImgState);
    }
    if (getImgStatus) {
      getImgStatus(false);
    }
  }
  const handleChangeRange = (e: any) => {
    const oRange = e.target.value;
    if (getRange) {
      getRange(oRange);
    }
    setRange(oRange);
    imgState && setBgPosition(`${(oRange / 100) * (imgState?.imgLeft * 2 + imgState?.imgWidth) - imgState?.imgLeft}px`);
  };

  useEffect(() => {
    setRange(defaultRange);
  }, [defaultRange]);

  // 当 imgList 变化时，重置 imgState 并重新加载图片尺寸
  useEffect(() => {
    // getImageSize();
  }, [imgList]);

  useEffect(() => {
    if (window.outerWidth <= 768) {
      if (getIsMoblie) {
        getIsMoblie(true);
      }
    }
  }, [getIsMoblie]);

  async function handleImgError() {
    if (getImgStatus) {
      getImgStatus(false);
    }
  }

  return (
    <>
      {
        <div className="ai-demo-beerslider-media" ref={containerRef}>
          <div id="beer-slider" className="beer-slider beer-ready" style={{ width: `${imgState?.imgWidth}px` }}>
            <div className="png-bg">
              {/* 原图 */}
              <span className="beer-after-title" style={{ left: `${range}%` }}>
                {tips[1]}
              </span>
              <img
                src={imgList[1]}
                alt=""
                ref={imgRef}
                onLoad={getImageSize}
                onError={handleImgError}
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            </div>
            <div className="beer-reveal" data-before-label={tips[0]} style={{ width: '100%' }}>
              {imgState && (
                <div
                  style={{
                    width: imgState.imgWidth,
                    height: imgState.imgHeight,
                    margin: '0 auto',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      width: imgState.imgWidth * range / 100,
                      height: imgState.imgHeight,
                      backgroundImage: `Url(${imgList[0]})`,
                      backgroundSize: `${imgState.imgWidth}px ${imgState.imgHeight}px`,
                    }}
                  ></div>
                </div>
              )}
            </div>
            <input
              className="beer-range"
              type="range"
              data-aria-label="Percent of revealed content"
              data-aria-valuemin="0"
              data-aria-valuemax="100"
              step="1"
              aria-valuenow={range}
              value={range}
              min="0"
              max="100"
              onChange={e => handleChangeRange(e)}
            />

            <span className="beer-handle" style={{ left: `${range}%` }}></span>
          </div>
        </div>
      }
    </>
  );
};

export default ImageSplitOptimize;
